import { render, staticRenderFns } from "./TailWizard.vue?vue&type=template&id=6bb6445e&scoped=true"
import script from "./TailWizard.vue?vue&type=script&lang=js"
export * from "./TailWizard.vue?vue&type=script&lang=js"
import style0 from "./TailWizard.vue?vue&type=style&index=0&id=6bb6445e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6445e",
  null
  
)

export default component.exports